<template>
    <div class="com-apply-email">
        <step-header activeKey="2"></step-header>
        <div class="com-apply-email__main">
            <div class="com-card-title">设置发件邮箱</div>
            <div class="com-apply-email__form com-form">
                <div :class="['com-form-item', {'is-error': error.email}]">
                    <label class="com-form__item-label">邮箱 </label>
                    <input class="com-form__item-input" type="text" v-model="smtp.email" @input="enter" />
                    <span class="com-form__item-explain" v-if="error.email">请输入邮箱</span>
                    <span class="com-form__item-explain" v-if="error.pattern">邮箱格式错误</span>
                </div>
                <div :class="['com-form-item', {'is-error': error.password}]">
                    <label class="com-form__item-label">密码 </label>
                    <input class="com-form__item-input" type="text" v-model="smtp.password" @input="enter" />
                    <span class="com-form__item-explain" v-if="error.password">请输入密码</span>
                </div>
                <div class="com-form-item com-form-item--nolabel">
                    <p class="text">请注意：需要开启邮箱的SMTP发送服务，才能正常发送邮件 <a href="/smtp" target="_blank" rel="noopener noreferer" style="color: #ff522d;text-decoration: underline">查看如何开启 >></a></p>
                </div>
            </div>
            <div class="com-card-title">设置公众号</div>
            <div class="com-apply-email__form com-form">
                <div :class="['com-form-item', {'is-error': error.public_no_name}]">
                    <label class="com-form__item-label">微信号 </label>
                    <input class="com-form__item-input" type="text" v-model="wx_info.public_no_name" @input="enter" />
                    <span class="com-form__item-explain" v-if="error.public_no_name">请输入微信号</span>
                </div>
                <div :class="['com-form-item', {'is-error': error.qr_code}]">
                    <label class="com-form__item-label">二维码 </label>
                    <file-upload
                        class="com-btn"
                        @input-filter="inputFilter"
                        @input-file="inputFile"
                        ref="upload">
                        <i class="icon icon-loading" v-if="uploading"/>
                        上传图片
                    </file-upload>
                    <!-- <input class="com-form__item-input" type="text" v-model="logo" @input="enter" /> -->
                    <span class="com-form__item-explain" v-if="error.qr_code">请上传二维码</span>
                </div>
                <div class="com-form-item com-form-item--nolabel" v-if="wx_info.qr_code">
                    <img :src="wx_info.qr_code" class="qr"/>
                </div>
                <div class="com-form-item com-form-item--nolabel">
                    <button class="com-btn com-btn-submit" @click="back" style="margin-right: 10px;">上一步</button>
                    <button class="com-btn com-btn-primary com-btn-submit" @click="next">下一步</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StepHeader from './step-header'
import * as xml2js from 'xml2js';
export default {
    name: 'apply-email',
    components: {
        StepHeader,
    },
    data() {
        return {
            smtp: {},
            wx_info: {},
            error: {},
            uploading: false
        }
    },
    created() {
        const params = JSON.parse(sessionStorage.getItem('params') || '{}');
        this.smtp = params.smtp || {};
        this.wx_info = params.wx_info || {};
    },
    methods: {
        inputFilter(newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                if (!/\.(png?|jpg?|jpeg?|gif?PNG?|JPG?|JPEG?|GIF?)$/i.test(newFile.name)) {
                    alert('只能上传后缀名为jpg，png，jpeg，gif的图片文件')
                    return prevent()
                }
            }
        },
        inputFile(newFile, oldFile) {
            const _this = this;
            if (newFile) {
                const suffix = newFile.name.split('.')[1];
                _this.uploading = true;
                this.$axios.post('/common/oss-upload-token', {suffix}).then(res => {
                    const uploadParams = res.data.response.data;
                    const param = new FormData();
                    Object.entries(uploadParams.inputs).map(([key, value]) => param.append(key, value));
                    param.append('file', newFile.file);
                    if(res.data.meta.code === 0) {
                        this.$axios.post(uploadParams.url, param).then(oss => {
                            const {parseString} = xml2js;
                            parseString(oss.data, (err, result) => _this.wx_info.qr_code = result.PostResponse.Location);
                            _this.uploading = false;
                            _this.$set(_this.wx_info, 'qr_code', _this.wx_info.qr_code[0])
                            _this.$set(_this.error, 'qr_code', false)
                        })
                    }
                })
            }
        },
        enter() {
            if(this.smtp.email) {
                this.$set(this.error, 'email', false)
            }
            if(this.smtp.email && /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/g.test(this.smtp.email)) {
                this.$set(this.error, 'pattern', false)
            }
            if(this.smtp.password) {
                this.$set(this.error, 'password', false)
            } 
            if(this.wx_info.public_no_name) {
                this.$set(this.error, 'public_no_name', false)
            } 
            if(this.wx_info.qr_code) {
                this.$set(this.error, 'qr_code', false)
            }
        },
        back() {
            this.$router.push({path: `/merchant/apply`, query: {s: 1}});
            this.$emit('end')
        },
        next() {
            if(!this.smtp.email) {
                this.$set(this.error, 'email', true)
            }
            if(this.smtp.email && !/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/g.test(this.smtp.email)) {
                this.$set(this.error, 'pattern', true)
            }
            if(!this.smtp.password) {
                this.$set(this.error, 'password', true)
            } 
            if(!this.wx_info.public_no_name) {
                this.$set(this.error, 'public_no_name', true)
            } 
            if(!this.wx_info.qr_code) {
                this.$set(this.error, 'qr_code', true)
            }
            if(this.smtp.email && this.smtp.password && this.wx_info.public_no_name && this.wx_info.qr_code) {
                const params = JSON.parse(sessionStorage.getItem('params') || '{}');
                params.smtp = this.smtp;
                params.wx_info = this.wx_info;
                sessionStorage.setItem('params', JSON.stringify(params));
                this.$router.push({path: `/merchant/apply`, query: {s: 3}});
                this.$emit('end')
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .com-apply-email {
        &__form {
            margin-top: 30px;
        }
        .com-divider {
            margin: 40px 0 24px;
        }
        .com-btn-submit {
            width: 100px;
            border-radius: 20px;
            margin-top: 20px;
        }
        .qr {
            max-width: 120px;
        }
        .text {
            font-size: 0.25rem;
        }
    }
</style>

